import script from "./register.vue?vue&type=script&setup=true&lang=js"
export * from "./register.vue?vue&type=script&setup=true&lang=js"

import "./register.vue?vue&type=style&index=0&id=d653412c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\dslx464\\Desktop\\workspace\\chatgpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d653412c"]])

export default __exports__